export default function formatDateString(date: Date | string): string {
  let dateObj: Date | undefined
  if (typeof date === 'string') {
    dateObj = new Date(date)
  } else {
    dateObj = date
  }
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1
  const day = dateObj.getDate()
  const hours = dateObj.getHours()
  const minutes = dateObj.getMinutes()
  return `${day}-${month}-${year} ${hours}:${minutes}`
}

/**
 * Returns the extension of a file, given the file has an extension. If the fileName
 * does not include an extension, undefined is returned.
 * @param filename The file name to get the file extension from.
 */
export function getFileExtension(filename: string): string | undefined {
  if (!filename.includes('.')) return undefined
  return filename.split('.').pop()
}

/**
 * Returns the name of a file without its extension.
 */
export function getFileName(filename: string): string {
  if (filename.includes('.')) {
    return filename.split('.').slice(0, -1).join('.')
  }
  return filename
}
